export default __webpack_public_path__ + "static/media/property_250.0afe6200.png";